import {ConfigMigrationAnalyticsAction} from 'constants/AnalyticsConstants';

import {MigrationStep} from '../types/MigrationStep';
import {
  BaseConfigMigrationEventMetadata,
  CompletedTimedConfigMigrationEventMetadata,
  trackConfigMigrationEvent,
} from './CommonConfigMigrationAnalytics';

// Metadata
interface SharedValidationEventMetadata {
  step: MigrationStep;
  total_error_count?: number;
  object_type_to_error_count?: Record<string, number>;
}

export type InitiatedValidationEventMetadata = SharedValidationEventMetadata &
  BaseConfigMigrationEventMetadata;
export type CompletedValidationEventMetadata = SharedValidationEventMetadata &
  CompletedTimedConfigMigrationEventMetadata;

export function trackInitiatedValidateConfig(metadata: InitiatedValidationEventMetadata): void {
  trackConfigMigrationEvent(ConfigMigrationAnalyticsAction.INITIATED_VALIDATE_CONFIG, metadata);
}

export function trackCompletedValidateConfig(metadata: CompletedValidationEventMetadata): void {
  trackConfigMigrationEvent(ConfigMigrationAnalyticsAction.COMPLETED_VALIDATE_CONFIG, metadata);
}
